export type OnboardingScope = 'parent' | 'child'

// Change this to "parent" if you want onboarding once per parent account.
// Keep "child" if you want each child profile to see it once.
export const ONBOARDING_SCOPE: OnboardingScope = 'child'

function keyForParent(userId: string) {
  return `inkwelljr:onboarding:parent:${userId}`
}

function keyForChild(childId: string) {
  return `inkwelljr:onboarding:child:${childId}`
}

export function hasCompletedOnboarding(opts: { userId?: string; childId?: string }) {
  const { userId, childId } = opts

  if (ONBOARDING_SCOPE === 'parent') {
    if (!userId) return false
    return localStorage.getItem(keyForParent(userId)) === '1'
  }

  if (!childId) return false
  return localStorage.getItem(keyForChild(childId)) === '1'
}

export function setCompletedOnboarding(opts: { userId?: string; childId?: string }) {
  const { userId, childId } = opts

  if (ONBOARDING_SCOPE === 'parent') {
    if (!userId) return
    localStorage.setItem(keyForParent(userId), '1')
    return
  }

  if (!childId) return
  localStorage.setItem(keyForChild(childId), '1')
}

export function clearOnboarding(opts: { userId?: string; childId?: string }) {
  const { userId, childId } = opts

  if (ONBOARDING_SCOPE === 'parent') {
    if (!userId) return
    localStorage.removeItem(keyForParent(userId))
    return
  }

  if (!childId) return
  localStorage.removeItem(keyForChild(childId))
}
